import { Component, OnInit } from '@angular/core';
import { Labels } from'src/app/constants/labels';
import { ColumnHeader } from 'src/app/models/column-header';
import { SrcPath } from'src/app/constants/srcPath';
import { CommonService } from 'src/app/services/common-service/common.service';
import { isData } from 'src/app/utils/utils';
import { KEYS } from'src/app/constants/keys';
import { UserPageDetails } from 'src/app/models/user-page-details';
import {ActivatedRoute } from '@angular/router';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';

@Component({
  selector: 'app-audit-trial-admin',
  templateUrl: './audit-trial-admin.component.html',
  styleUrls: ['./audit-trial-admin.component.scss'],
  imports:[CommonModule,SharedModule]
})
export class AuditTrialAdminComponent implements OnInit {
  pageDetails!: UserPageDetails;
  headerData: ColumnHeader |any;
  pageLabel = Labels.buttons;
  auditData: any = [];
  constructor(private commonService: CommonService,private route: ActivatedRoute) { }

  ngOnInit(): void {
   this.initColumnHeader();      
    let fromPopup=sessionStorage.getItem('ifpopup');
    this.commonService.ogLog("frompopup:",fromPopup);
    if(fromPopup =='1'){
      let details=JSON.parse(sessionStorage.getItem('tabDetails')!);
      let id =details[0].pageId;      
      let frompage=details[0].fromPage;  
      let controlId= details[0].controlId;
      this.loadAuditTrialData(id,controlId,frompage);
      sessionStorage.removeItem("ifpopup");
      sessionStorage.removeItem("tabDetails");
    }
    else
    {
    this.route.queryParams.subscribe(params => {
     const id = params['pageId'];
      const frompage=params['fromPage'];
      const controlid=(params['controlId']==null?0:params['controlId']);     
      this.loadAuditTrialData(id,controlid,frompage);
    });  
  }
   
  }

  private initColumnHeader() {
    this.headerData = {
      title: Labels.auditTrial.title,
      button: {
        show: false
      },
      topButton: {
        show: true,
        property: [         
          {
            title: Labels.auditTrial.back_menu,
            icon: SrcPath.previousIcon,
            class: Labels.auditTrial.class
          }
        ]
      }
    };
  }

  loadAuditTrialData(pageId: any,primaryKey: any,frompage: any) {
    this.commonService.loadAuditTrialDataAdmin(pageId,primaryKey,frompage).subscribe((data :any)=> {
      if (isData(data)) {
        this.commonService.ogLog("Data:", data['table']);
        var datas = data['table'];
        for (let j = 0; j < datas.length; j++) {
          this.auditData.push(
            {
              "gstibo_action": datas[j].gstibo_action,
              "gstibo_created_on": datas[j].gstibo_created_on,
              "gstibo_User": datas[j].gstibo_account_firstname + " " + datas[j].gstibo_account_lastname,
              "gstibo_ip_address": datas[j].gstibo_ip_address,
              "gstibo_machine_name": datas[j].gstibo_machine_name,
              "log": (datas[j].gstibo_audit_log).split("~~~")
            }
          );
        } 
      }
    });
  }

}
